<template>
  <div>
    <div class="list-container">
      <ul class="list-box">
        <li class="list-item" v-for="item in bannerList" :key="item.bannerId">
          <img @click="goBanner(item)" :src="linkAllImgUrl(item.imageUrl)" alt />
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
import { getBannerApi } from "@/api/user";
import commonMixin from "@/mixins/commonMixin";

export default {
  mixins: [commonMixin],
  data() {
    return {
      bannerList: []
    };
  },
  created() {
    this.getBanner();
  },
  computed: {},
  methods: {
    getBanner() {
      /* 1 首页 2 搜索页 3 活动页 */
      getBannerApi({ position: 3 }).then(res => {
        if (res.code == 200) {
          this.bannerList = res.data;
        }
      });
    },
    goBanner(item) {
      if (item.type == 2) {
        window.location.href = item.jumpUrl;
      }
    }
  },
};
</script>

<style lang="less" scoped>
.list-container {
  padding-top: 20px;
  overflow: hidden;
  .list-box {
    overflow: hidden;
    width: 1000px;
    .list-item {
      float: left;
      margin-left: 20px;
      margin-bottom: 20px;
      width: 450px;
      height: 180px;
      cursor: pointer;
      img {
        width: 100%;
        height: 100%;
      }
    }
  }
}
</style>